import { IRecentClient } from '../types/recentClients';

const RECENT_CLIENTS_KEY = 'mysalecycle-recent-clients';

export function getAllFromLocalStorage() {
  const recentClientsJson = localStorage.getItem(RECENT_CLIENTS_KEY);
  const recentClients: IRecentClient[] = recentClientsJson ? JSON.parse(recentClientsJson) : [];
  return recentClients;
}

export function addToLocalStorage(level: string, id: string) {
  const recentClients: IRecentClient[] = getAllFromLocalStorage();
  const exists = recentClients.find(c => c.id === id);
  if (!exists) {
    recentClients.push({ level, id });
    if (recentClients.length > 5) {
      recentClients.shift();
    }
    localStorage.setItem(RECENT_CLIENTS_KEY, JSON.stringify(recentClients));
  }
}

export function removeFromLocalStorage() {
  localStorage.removeItem(RECENT_CLIENTS_KEY);
}
